
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { isOnFreePlan } from '@/ui/auth/auth';
  import { Button } from '@/ui/components/Button';
  import UpgradeButton from './UpgradeButton.vue';
  import ReconfigureButton from './ReconfigureButton.vue';
  import DeleteButton from './DeleteButton.vue';
  import PauseButton from './PauseButton.vue';
  import { computed, defineComponent, ref } from 'vue';

  export default defineComponent({
    components: {
      UpgradeButton,
      ReconfigureButton,
      DeleteButton,
      PauseButton,
      Button,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const isActivated = computed(() => store.isActivated);
      const loading = ref(false);
      const setLoading = (value: boolean) => {
        loading.value = value;
      };

      return {
        isOnFreePlan,
        loading,
        setLoading,
        isActivated,
      };
    },
  });
